import React, { createContext, useState, useEffect } from 'react';

export const PosterContext = createContext(null);

export const PosterProvider = ({ socket, children }) => {
  const [posters, setPosters] = useState({});

  useEffect(() => {
    socket.on('reaction_updated', ({ id: posterId, reactionCountNumber, type }) => {
      
      setPosters(prev => prev.map(poster => {
        if(poster.id === posterId) {
          const reactionCountNumberLabel = `reaction_count_${reactionCountNumber}`
          const currentCountNumber = poster[reactionCountNumberLabel]
          const adjustment = type === 'inc' ? 1 : -1;
          
          return {
            ...poster,
            [reactionCountNumberLabel]: currentCountNumber + adjustment
          }
        }
        
        return poster;
      }))
    });

    socket.on('get_posters', ({ posters }) => {
      console.log('Received posters data:', posters);
      setPosters(posters);
    });


    return () => {
      socket.off('reaction_updated');
      socket.off('get_posters');
    };
  }, [socket]);

  const getReactions = (posterId) => {
    socket.emit('get_reactions', posterId);
  };

  const getPosters = (latitude, longitude) => {
    console.log('Emitting get_posters with:', { latitude, longitude });
    socket.emit('get_posters', {
      latitude,
      longitude
    });
  };

  const sendReaction = (posterId, reactionCountNumber, type) => {
    socket.emit('reaction', {
      id: posterId,
      reactionCountNumber: reactionCountNumber,
      type: type
    });
  };

  return (
    <PosterContext.Provider value={{ getReactions, sendReaction, posters, getPosters, setPosters }}>
      {children}
    </PosterContext.Provider>
  );
};
